<template>
  <router-link v-if="canAccessPath($router, to)" :to="to">
    <slot />
  </router-link>
</template>

<script>
import { canAccessPath } from '@/utils/routeAccess.js';

export default {
  name: 'AccessHandledRouterLink',
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    canAccessPath,
  },
};
</script>
